import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

export default router;

export const pages = [
  'video', 'details', 'tour360', 'gallery', 'slideshow', 'floorplan', 'documents', 'walkScore', 'map', 'contact'
];
